'use client';

import React from 'react';

const ZODIAC_ITEMS = [
  { glyph: '♈', name: 'Mesha', hiName: 'मेष' },
  { glyph: '♉', name: 'Vrishabha', hiName: 'वृषभ' },
  { glyph: '♊', name: 'Mithuna', hiName: 'मिथुन' },
  { glyph: '♋', name: 'Karka', hiName: 'कर्क' },
  { glyph: '♌', name: 'Simha', hiName: 'सिंह' },
  { glyph: '♍', name: 'Kanya', hiName: 'कन्या' },
  { glyph: '♎', name: 'Tula', hiName: 'तुला' },
  { glyph: '♏', name: 'Vrishchika', hiName: 'वृश्चिक' },
  { glyph: '♐', name: 'Dhanu', hiName: 'धनु' },
  { glyph: '♑', name: 'Makara', hiName: 'मकर' },
  { glyph: '♒', name: 'Kumbha', hiName: 'कुम्भ' },
  { glyph: '♓', name: 'Meena', hiName: 'मीन' },
];

export function ZodiacTicker({ locale }: { locale: string }) {
  const isHindi = locale === 'hi';

  const renderRow = (keyPrefix: string) =>
    ZODIAC_ITEMS.map((item, i) => (
      <span
        key={`${keyPrefix}-${i}`}
        className="inline-flex items-center gap-3 px-8 whitespace-nowrap font-heading text-base font-normal text-[rgba(225,230,255,0.85)]"
      >
        <span className="text-xl text-[#b9c6ff] drop-shadow-[0_0_12px_rgba(150,165,255,0.9)]">
          {item.glyph}
        </span>
        <span>{isHindi ? item.hiName : item.name}</span>
        <span className="ml-8 text-[rgba(185,168,255,0.5)]">✦</span>
      </span>
    ));

  return (
    <div
      className="w-screen relative left-1/2 -translate-x-1/2 overflow-hidden py-4 border-y border-white/10 bg-[rgba(10,14,50,0.35)] backdrop-blur-md"
      data-testid="zodiac-ticker"
      aria-hidden="true"
    >
      <div className="flex w-max motion-safe:animate-[marquee_60s_linear_infinite]">
        {renderRow('row1')}
        {renderRow('row2')}
      </div>
    </div>
  );
}
